import type { SVGProps } from 'react';

export default function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M14.5 3c.2 2 1.2 3.8 3.2 5 1 .6 2.1 1 3.3 1.1v3.4c-2.5-.1-4.7-1-6.5-2.6v7.2c0 1.2-.3 2.4-.9 3.5-1 1.8-2.9 3.1-5.2 3.3-1.8.2-3.6-.4-4.9-1.6-1.3-1.2-2-3-1.8-4.8.2-2.7 2.3-4.9 5-5.3.6-.1 1.2-.1 1.8 0v3.6c-.5-.1-1-.1-1.5 0-1.1.3-1.9 1.3-2 2.4-.1.8.2 1.6.8 2.1.6.5 1.4.7 2.2.5 1.2-.3 2.1-1.4 2.1-2.7V3h3.4Z"
        fill="currentColor"
      />
    </svg>
  );
}

